import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserMailDeliveryGame from 'src/games/MailDeliveryGame/Main';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(LandscapingGame)'
interface MailDeliveryGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;

}

interface MailDeliveryGameState {
}

class MailDeliveryGame extends React.Component<MailDeliveryGameProps, MailDeliveryGameState> {
    constructor(props: MailDeliveryGameProps) {
        super(props);
        bindAllOfThis(this, MailDeliveryGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserMailDeliveryGame onComplete={this.completeGame} />
        </div>;
    }
}

export default MailDeliveryGame;



// WEBPACK FOOTER //
// ./src/pages/game/MailDeliveryGame.tsx